/* global moment */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackCampaignsEditController', WinbackCampaignsEditController);

    WinbackCampaignsEditController.$inject = ['debug', '$stateParams', 'i18n', 'API', 'helpers', '$state', 'alert',];

    function WinbackCampaignsEditController(debug, $stateParams, i18n, API, helpers, $state, alert) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.campaign = {};
        vm.winbackOffers = [];
        vm.loadingState = {
            campaign: false,
            winbackOffers: false,
        };
        vm.now = helpers.getDatabaseDatetime();
        vm.openRemoveModal = openRemoveModal;

        activate();

        function activate() {
            loadCampaign();
            loadWinbackOffers();
        }

        function loadCampaign() {
            vm.loadingState.campaign = true;
            API.WinbackCampaign.get({ id: vm.id, }).$promise.then(function (response) {
                if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(response.active_from)) {
                    response.active_from = moment(response.active_from).toDate();
                }

                if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(response.active_to)) {
                    response.active_to = moment(response.active_to).toDate();
                }

                angular.extend(vm.campaign, response);

                vm.loadingState.campaign = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function loadWinbackOffers() {
            vm.loadingState.winbackOffers = true;
            var promise = API.WinbackOffer.search({ type: 'campaign' }).$promise;

            promise.then(function (response) {
                if (response.items.length) {
                    vm.winbackOffers = [];
                    angular.forEach(response.items, function (game) {
                        vm.winbackOffers.push({
                            name: game.name,
                            label: game.name,
                            value: game.id
                        });
                    });
                }
            }, function (response) {
                debug.log(response);
            })
                .finally(function () {
                    vm.loadingState.winbackOffers = false;
                });
        }

        function save() {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            var campaign = angular.copy(vm.campaign);

            if (campaign.active_from) {
                campaign.active_from = moment(campaign.active_from).format('YYYY-MM-DD 00:00:00');
            }

            if (campaign.active_to) {
                campaign.active_to = moment(campaign.active_to).format('YYYY-MM-DD 23:59:59');
            }

            API.WinbackCampaign.save({}, campaign).$promise.then(function (response) {
                if (response.id) {
                    angular.extend(vm.campaign, response);
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadCampaign();
                }
            }, function () {
            })
                .finally(function () {
                    vm.isSaving = false;
                });
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item');

            promise.then(function () {
                var removePromise = API.WinbackCampaign.recycle({ id: vm.id }).$promise;

                removePromise.then(function () {
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('USER_RECYCLED') });
                    $state.go('winbackCampaigns.list');
                }, function () {
                });
            }, function () {
            });
        }
    }
})();